module.exports = __webpack_public_path__ + "f0a93d0fe2e466f71130bf2fec27f7e2.svg";